import { random } from 'lodash';
import { z } from 'zod';
import { legalTransactionRelationshipData } from './ILegalTransactionRelationshipData';
import { legalTransactionRelationshipDocumentSchema } from './ILegalTransactionRelationshipDocument';
import { legalTransactionRelationshipMemberSchema } from './ILegalTransactionRelationshipMember';
import { legalTransactionRelationshipRealEstateSchema } from './ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { partnerIdentifierSchema } from './IPartnerIdentifier';
import { LegalTransactionRelationshipTypeEnum } from './LegalTransactionRelationshipTypeEnum';

export const legalTransactionRelationshipSchema = z.object({
  idRelationship: z.number(),
  idRelationshipType: z.nativeEnum(LegalTransactionRelationshipTypeEnum),
  RelationshipType: z.string(),
  idLegalTransaction: z.number(),
  isActiveRelationship: z.boolean(),
  companyFormationLegalTransaction: z.string().nullable().optional(),
  isCompanyFormation: z.boolean(),
  data: legalTransactionRelationshipData.nullable().optional(),
  syncWithArnoTop: z.boolean(),
  Created: z.date(),
  Updated: z.date(),
  Members: z.array(legalTransactionRelationshipMemberSchema),
  DocumentArray: z.array(legalTransactionRelationshipDocumentSchema),
  RealEstateArray: z.array(legalTransactionRelationshipRealEstateSchema),
  PartnerIdentifiers: z.array(partnerIdentifierSchema),
});

export type ILegalTransactionRelationship = z.infer<
  typeof legalTransactionRelationshipSchema
>;

export const initLegalTransactionRelationship =
  (): ILegalTransactionRelationship => ({
    idRelationship: -random(1, Number.MAX_SAFE_INTEGER),
    idRelationshipType: LegalTransactionRelationshipTypeEnum.PurchaseContract,
    RelationshipType: '',
    idLegalTransaction: 0,
    isActiveRelationship: true,
    companyFormationLegalTransaction: null,
    isCompanyFormation: false,
    data: null,
    syncWithArnoTop: false,
    Created: new Date(),
    Updated: new Date(),
    Members: [],
    DocumentArray: [],
    RealEstateArray: [],
    PartnerIdentifiers: [],
  });
